import React from "react";
import ModalWrapper from "./ModalWrapper";
import { Stack } from "@mui/material";
import TextView from "../TextView";
import { ASSETS } from "../../utils/config";
import { colors } from "../../utils";

function UpdateLiveClones({
  isOpen,
  handleClose,
  onBroadCastPress = () => {},
  onSaveExitPress = ()=>{},
  onExitPress = ()=>{},
  cancelButtonVisible = true,
  modalText = "Some Description",
  title = "Broadcast Wheel Update!",
  prefixIcon = ASSETS.BroadCastIcon,
  buttonText = "buttonText",
  buttonLoading = false,
  repeatButtonText,
  
  
}) {
  return (
    <ModalWrapper
      isOpen={isOpen}
      handleClose={handleClose}
      onSubmit={onBroadCastPress}
      isCancelButtonVisible={cancelButtonVisible}
      iconKey="clone"
      title={title}
      prefixIcon={prefixIcon}
      buttonText={buttonText}
      cancelButtonText={"Exit"}
      buttonLoading={buttonLoading}
      repeatButtonText={repeatButtonText}
      onRepeat={onSaveExitPress}
      onCencelButtonPress={onExitPress}
    >
      <Stack sx={{ mt: 2 }}>
        <TextView color={colors.textGrey} variant="largeText">
          {modalText}
        </TextView>
      </Stack>
    </ModalWrapper>
  );
}

export default UpdateLiveClones;
